import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { listLeftDatas } from "./list-left";
import { HiMiniSquares2X2 } from "react-icons/hi2";
import ListLeftResponsive from "./ListLeftResponsive";
import { AuthContext } from "../../contexts/AuthContext";
import { socket } from "../../services/socket";
import { includesId } from "../../services/idUtils";
import { useMeeting } from "../../hooks/useMeeting";

export default function ListLeft() {
  const [display, setDisplay] = useState(false);
  const [nombreDeSms, setNombreDeSms] = useState(0);
  const [nombreDeSmsGroupe, setNombreDeSmsGroupe] = useState(0);
  const [hasNewAnnonces, setHasNewAnnonces] = useState(false);
  const { user } = useContext(AuthContext);
  const { isMeetingActive } = useMeeting();

  useEffect(function () {
    socket.emit("tous_mes_messages_inbox_non_lus", user.userId);
    socket.emit("tous_mes_messages_groupe_non_lus", user.userId);
    socket.emit("compter_annonces_non_vues", user.userId);
  }, []);

  useEffect(() => {
    socket.on("effacer_le_nombre_de_messages_inbox_non_lus", (nbrMsgNonLus) => {
      setNombreDeSms(nbrMsgNonLus);
    });

    socket.on("effacer_le_nombre_de_messages_groupe_non_lus", (nbr) => {
      setNombreDeSmsGroupe(nbr);
    });
    socket.on("tous_mes_messages_inbox_non_lus", (nbrMsgNonLus) => {
      setNombreDeSms(nbrMsgNonLus);
    });

    socket.on("tous_mes_messages_groupe_non_lus", (nbrMsgNonLus) => {
      setNombreDeSmsGroupe(nbrMsgNonLus);
    });

    socket.on("nouveau_message_groupe_au_compteur", (message) => {
      if (!includesId(message.openedBy, user.userId)) {
        setNombreDeSmsGroupe((prev) => {
          return prev + 1;
        });
      }
    });

    socket.on("nouveau_message_inbox_au_compteur", (message) => {
      if (!includesId(message.openedBy, user.userId)) {
        setNombreDeSms((prev) => {
          return prev + 1;
        });
      }
    });

    // Annonces
    socket.on("nombre_annonces_non_vues", (count) => {
      setHasNewAnnonces(count > 0);
    });

    socket.on("annonces_toutes_vues", () => {
      setHasNewAnnonces(false);
    });

    socket.on("nouvelle_annonce_broadcast", (annonce) => {
      // Ne pas afficher le badge pour l'émetteur de l'annonce
      const emetteurId = annonce?.emetteur?._id || annonce?.emetteur;
      if (emetteurId === user.userId) return;
      setHasNewAnnonces(true);
    });

    return () => {
      socket.off("effacer_le_nombre_de_messages_inbox_non_lus");
      socket.off("effacer_le_nombre_de_messages_groupe_non_lus");
      socket.off("nouveau_message_inbox_au_compteur");
      socket.off("nouveau_message_groupe_au_compteur");
      socket.off("tous_mes_messages_inbox_non_lus");
      socket.off("tous_mes_messages_groupe_non_lus");
      socket.off("nombre_annonces_non_vues");
      socket.off("annonces_toutes_vues");
      socket.off("nouvelle_annonce_broadcast");
    };
  }, [socket]);

  return (
    <>
      <ul className="tyn-appbar-nav tyn-appbar-nav-start">
        {listLeftDatas.map((element, index) => (
          <li className="tyn-appbar-item d-none d-sm-inline-flex" key={index}>
            {index === 0 ? (
              <>
                <Link
                  className={element.linkClass}
                  to={element.linkTo}
                >
                  {element.icon}
                  <div className="badge bg-primary position-absolute rounded-pill top-0 end-0 mt-n1 me-n1">
                    {nombreDeSms === 0 ? "" : nombreDeSms}
                  </div>
                </Link>
              </>
            ) : index === 2 ? (
              <Link
                className={element.linkClass}
                to={element.linkTo}
              >
                {element.icon}
                <div
                  className="badge bg-primary position-absolute rounded-pill mt-n1 me-n1"
                  style={{ top: "18px", left: "290px" }}
                >
                  {nombreDeSmsGroupe === 0 ? "" : nombreDeSmsGroupe}
                </div>
              </Link>
            ) : index === 3 ? (
              <Link
                className="tyn-appbar-link position-relative"
                to={element.linkTo}
              >
                {element.icon}
                {hasNewAnnonces && element.indicator}
              </Link>
            ) : (
              <>
                <Link
                  className={`${element.linkClass} ${element.linkTo === "/reunion" && isMeetingActive ? "position-relative" : ""}`}
                  to={isMeetingActive && element.linkTo === "/reunion" ? "/reunion-start" : element.linkTo}
                >
                  {element.icon}
                  {element.linkTo === "/reunion" && isMeetingActive && (
                    <span
                      style={{
                        position: "absolute",
                        top: "2px",
                        right: "2px",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: "#00b074",
                        boxShadow: "0 0 6px rgba(0,176,116,0.6)",
                      }}
                    />
                  )}
                </Link>
              </>
            )}
          </li>
        ))}
        <li className="tyn-appbar-item dropdown">
          <button
            style={{ border: "0 none transparent" }}
            className="dropdown-menu-responsive-toggle-button tyn-appbar-link d-sm-none dropdown-toggle"
            data-bs-toggle="dropdown"
            to="#"
            data-bs-offset="0,10"
            onClick={(evt) => {
              evt.stopPropagation();
              setDisplay(!display);
            }}
          >
            <HiMiniSquares2X2 style={{ position: "relative" }} />
            {nombreDeSms !== 0 || nombreDeSmsGroupe !== 0 || hasNewAnnonces ? (
              listLeftDatas[0].indicator
            ) : (
              <></>
            )}
          </button>
          <ListLeftResponsive
            display={display}
            setDisplay={setDisplay}
            nombreDeSms={nombreDeSms}
            nombreDeSmsGroupe={nombreDeSmsGroupe}
          />
        </li>
      </ul>
    </>
  );
}
